const domainHost = (): string => {
  let domain = 'alibaba.com';
  try {
    domain = 'alibaba' + window.location.hostname.split('.alibaba').slice(1)[0];
  } catch (error) {
    console.warn(JSON.stringify(error));
  }
  return domain;
};

export { domainHost };

type Site = 'de' | 'uk' | 'turkey' | 'cn';
export default (): Site | undefined => {
  const hostArr = window.location.host.split('.');

  if (hostArr[0] === 'turkey' || hostArr[0] === 'turkiye') return 'turkey';
  if (hostArr[0] === 'germany') return 'de';
  if (hostArr[0] === 'chinese') return 'cn';
  if (hostArr[hostArr.length - 1] === 'uk') return 'uk';
  if (hostArr[hostArr.length - 1] === 'de') return 'de';
};
